import { render, staticRenderFns } from "./UserIcon.vue?vue&type=template&id=29561168&scoped=true"
import script from "./UserIcon.vue?vue&type=script&lang=js"
export * from "./UserIcon.vue?vue&type=script&lang=js"
import style0 from "./UserIcon.vue?vue&type=style&index=0&id=29561168&prod&scoped=true&lang=css"
import style1 from "./UserIcon.vue?vue&type=style&index=1&id=29561168&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29561168",
  null
  
)

export default component.exports